import React, { createContext, ReactNode, useContext } from 'react';
import api from '../services/api';

interface TransactionContextProps {
  getStripePublishableKey: () => Promise<string>;
  createPaymentIntent: (orderId: string) => Promise<string>;
}

const TransactionContext = createContext<TransactionContextProps | undefined>(
  undefined,
);

export const TransactionProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const apiUrl = process.env.REACT_APP_API_URL + '/transactions';

  const getStripePublishableKey = async (): Promise<string> => {
    const response = await api.get(`${apiUrl}/config`);
    return response.data.stripePublishableKey;
  };

  const createPaymentIntent = async (orderId: string): Promise<string> => {
    const response = await api.post(`${apiUrl}/create-payment-intent`, { orderId });
    return response.data.clientSecret;
  };

  return (
    <TransactionContext.Provider
      value={{ getStripePublishableKey, createPaymentIntent }}
    >
      {children}
    </TransactionContext.Provider>
  );
};

export const useTransaction = (): TransactionContextProps => {
  const context = useContext(TransactionContext);
  if (!context) {
    throw new Error('useTransaction must be used within a TransactionProvider');
  }
  return context;
};
